import { ACTION_TYPE } from '../core/redux/actionType';
import { IAppState } from '../core/redux/IAppState';
import { Action } from 'redux';
import {ResortMappingObject, RTPMappingProduct, SiriuswareMappingProduct} from './productMappings';
import {assoc} from '../language/module';


type UpdateRowAction = {
  type: ACTION_TYPE.UPDATE_RESORT_MAPPING_ROW;
  payload: RTPMappingProduct | SiriuswareMappingProduct;
};

/**
 * Makes and action that can be dispatched to update product mappings in local state
 * @param payload
 */
export const updateRowAction = (
  payload: RTPMappingProduct | SiriuswareMappingProduct,
): UpdateRowAction => ({
  type: ACTION_TYPE.UPDATE_RESORT_MAPPING_ROW,
  payload: payload
});

export const updateRowReducer = (state: IAppState, action: Action): IAppState => {

  if (action.type !== ACTION_TYPE.UPDATE_RESORT_MAPPING_ROW) return state;

  const rowAction = action as UpdateRowAction;
  const updatedRow = rowAction.payload as RTPMappingProduct;
  const isRtp = state.resortMappingHistories.posProvider === 'RTP';

  if (!updatedRow) return state;


  const updatedEntitlementArray = state.resortMappingHistories.productMappings.map((element) =>
    element.id === updatedRow.id ? updatedRow : element
  );

  const newObj: ResortMappingObject = {
    posProvider: isRtp ? 'RTP' : 'Siriusware',
    productMappings: updatedEntitlementArray,
    hasError: state.resortMappingHistories.hasError
  };

  return assoc('resortMappingHistories', newObj, state);

}